import { render, staticRenderFns } from "./TagFormatter.vue?vue&type=template&id=3159eb1b&scoped=true&"
import script from "./TagFormatter.vue?vue&type=script&lang=js&"
export * from "./TagFormatter.vue?vue&type=script&lang=js&"
import style0 from "./TagFormatter.vue?vue&type=style&index=0&id=3159eb1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3159eb1b",
  null
  
)

export default component.exports